import { messageType } from "assets/constants";
import { CheckCircleIconSuccess, ErrorIcon, InformationIcon, ScriptMessage, WarningIconStyle } from "./styles";

/**
 * CustomMessage component displays a message with an icon based on the message type.
 *
 * @component
 * @param {Object} props - The properties object.
 * @param {string} props.message - The message to be displayed.
 * @param {number} props.type - The type of the message which determines the icon to be displayed.
 *                                      It can be one of the following values: "success", "warning", "error", or any other value for an information icon.
 * @returns {JSX.Element} The rendered CustomMessage component.
 */
const CustomMessage = ({ message, type }) => {

  const messageIcon = (type) => {
    switch (type) {
      case messageType.success:
        return <CheckCircleIconSuccess fontSize="inherit" />;
      case messageType.warning:
        return <WarningIconStyle fontSize="inherit" />;
      case messageType.error:
        return <ErrorIcon fontSize="inherit" />;
      default:
        return <InformationIcon fontSize="inherit" />;
    }
  }
  return (
    <ScriptMessage color={messageType[type]} icon={messageIcon(type)}>
      {message}
    </ScriptMessage>
  );
}

export default CustomMessage;